import type { TContractDurationUnit } from "@bbj-types/offer";

export const TRAINING_OFFER_DURATION_UNIT_LABELS: Record<TContractDurationUnit, string> = {
  day: "jours",
  week: "semaines",
  month: "mois",
  year: "ans",
};
